import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history'
import { Router, Route, Switch } from 'react-router-dom'
import ConfigProviderWithLocale from './components/ConfigProviderWithLocale'
import { Provider } from 'react-redux'
import store from './redux/store'
import * as Sentry from '@sentry/react'

import './i18n'
import './utils/proxy'
import './index.css'
import './theme.css'
import './typography.css'
import './components/DrawerActions.css'
import './components/AccountConsistency.css'

Sentry.init({
  dsn: "https://b01a4dcce8eb407c96a64c221cf6e827@sen.idevbase.com/7",
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 1.0,
});

window.sentry = Sentry

const IndexLayout = React.lazy(() => import('./layouts/Index'))
const MonitorLayout = React.lazy(() => import('./layouts/Monitor'))
const GuideLayout = React.lazy(() => import('./layouts/Guide'))

const history = createBrowserHistory()

class SuspenseFallback extends React.Component {
  componentDidMount() {
    const loader = document.querySelector('.loader-container')
    loader.classList.remove('load-spinner-close')
    loader.setAttribute('aria-hidden', 'false')
    document.getElementById('root').setAttribute('aria-busy', 'true')
  }

  componentWillUnmount() {
    const loader = document.querySelector('.loader-container')
    loader.classList.add('load-spinner-close')
    loader.setAttribute('aria-hidden', 'true')
    document.getElementById('root').removeAttribute('aria-busy')
  }

  render() {
    return null
  }
}

ReactDOM.render(
  <Provider store={store}>
    <ConfigProviderWithLocale>
      <Router history={history}>
        <React.Suspense fallback={<SuspenseFallback />}>
          <Switch>
            <Route path='/monitor' render={props => <MonitorLayout {...props} />} />
            <Route path='/guide' render={props => <GuideLayout {...props} />} />
            <Route path='/' render={props => <IndexLayout {...props} />} />
          </Switch>
        </React.Suspense>
      </Router>
    </ConfigProviderWithLocale>
  </Provider>,
  document.getElementById('root')
)
